import _ from 'lodash'

import AccommodationsList from './AccommodationsList'

const ItineraryItem = (props) => {
  const {
    itemIndex,
    accommodations,
    day,
    description,
    image,
    isExpanded,
    onExpand,
    title,
    showDays,
    isGetaway,
  } = props

  const collapsedClass = isExpanded ? 'expanded' : 'collapsed'
  const expandedClass = isExpanded ? 'expanded' : ''
  const buttonText = isExpanded ? 'Close' : 'View Details'

  return (
    <div id={`itinerary-item-${itemIndex}`} className="tour-itinerary__list__item">
       {itemIndex === 0 ? (<div className="tour-itinerary__list__item__legend-meals">
         <span className="tour-itinerary__list__item__legend-meals__header">Legend for Meals:</span> 
         <span className="tour-itinerary__list__item__legend-meals__text"> B</span> - Breakfast,
         <span className="tour-itinerary__list__item__legend-meals__text"> BR</span> - Brunch,
         <span className="tour-itinerary__list__item__legend-meals__text"> L</span> - Lunch,
         <span className="tour-itinerary__list__item__legend-meals__text"> D</span> - Dinner 
       </div>) : null}
      {!isGetaway && (
        <div className="tour-itinerary__list__item__header">
          <span className="tour-itinerary__list__item__header__label">
            {showDays && (
              <span className="tour-itinerary__list__item__header__day">
                Day {day}
              </span>
            )}
            <span className="tour-itinerary__list__item__header__title">
              {title}
            </span>
          </span>
          {showDays && Boolean(description || _.size(accommodations)) && (
            <button
              className={`tour-itinerary__list__item__header__button ${expandedClass}`}
              onClick={() => onExpand(`itinerary-item-${itemIndex}`)}
            >
              {buttonText}
            </button>
          )}
        </div>
      )}
      <div
        className={`tour-itinerary__list__item__content ${collapsedClass}`}
        style={{ minHeight: image && image.path ? 234 : '' }}
      >
        {image && image.path && (
          <img
            alt={image.description}
            className="tour-itinerary__list__item__content__image"
            src={image.path}
          />
        )}
        {description && (
          <p
            className="tour-itinerary__list__item__content__description"
            dangerouslySetInnerHTML={{ __html: description.replaceAll(/\s/g,' ') }}
          />
        )}
      </div>
      <AccommodationsList accommodations={accommodations} className={collapsedClass} />
    </div>
  )
}

export default ItineraryItem
